import React from "react";
import { validate } from "shared/yup";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { RootState } from "redux/store";
import { saveIntegration } from "redux/slice/integrations";
import { Integration } from "model/integration";
import { CustomLtsCard } from "./card";
import { CustomLtsModal, validationSchema } from "./modal";

const mapStateToProps = (_state: RootState) => ({});
const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({ saveIntegration }, dispatch);

interface Props extends ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps> {
	integration: Integration;
}

interface State {
	modalOpen: boolean;
	name?: string;
	url?: string;
	showValidation: boolean;
}

class Component extends React.Component<Props, State> {

	public constructor(props: Props) {
		super(props);
		this.state = {
			modalOpen: false,
			name: props.integration.name,
			url: props.integration.data.url as string,
			showValidation: false,
		};
	}

	public handleSave = () => {
		const { integration, saveIntegration } = this.props;
		const { name, url } = this.state;
		const errors = validate(validationSchema, this.state);
		this.setState({ showValidation: true });
		if (!errors) {
			saveIntegration({ integration: { ...integration, name, data: { ...integration.data, url } } });
		}
	};

	public render() {
		const { integration } = this.props;
		const { modalOpen, showValidation, name, url } = this.state;

		return (
			<>
				<CustomLtsCard
					integration={integration}
					onViewIntegration={() => this.setState({ modalOpen: true })}
				/>
				<CustomLtsModal
					open={modalOpen}
					onClose={() => this.setState({ modalOpen: false })}
					integration={integration}
					name={name}
					url={url}
					showValidation={showValidation}
					onNameChange={name => this.setState({ name })}
					onUrlChange={url => this.setState({ url })}
					onSave={this.handleSave}
				/>
			</>
		);
	}

}

export const CustomLtsIntegration = connect(mapStateToProps, mapDispatchToProps)(Component);
